module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add_email_address_for":"Add email address for sign in","enter_email_address":"Enter Email Address","request":"Request"},"id":{"add_email_address_for":"Tambah email address untuk Log in","enter_email_address":"Masukkan Email Address","request":"Minta"}}')
  delete Component.options._Ctor
}
